export default __webpack_public_path__ + "static/media/list-branch.0eba2b25.svg";